import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

export const PromoRoomAndDealsBanner = () => {
  return (
    <Paper
      as="article"
      className="rounded-md border border-divider px-10 py-6 text-center"
    >
      <Typography
        className="m-[0_auto] w-[80%] [text-wrap:unset] md:w-full"
        color="text.secondary"
        variant="subtitle1"
      >
        <FormattedMessage
          id="promo.offers.allDeals.banner"
          values={{
            highlight: (chunks) => (
              <Typography
                className="capitalize [font-size:inherit] [font-weight:inherit]"
                color="primary"
                component="span"
              >
                {chunks}
              </Typography>
            ),
          }}
        />
      </Typography>
      <Button
        className="mt-4 font-semibold"
        color="primary"
        component={Link}
        href="/app/deals"
        size="medium"
        variant="contained"
      >
        <FormattedMessage id="common.controls.viewAllRoomsAndDeals" />
      </Button>
    </Paper>
  )
}
